/**
 * Utilitários compartilhados do cronômetro de tarefas.
 *
 * Centraliza a regra de tempo ativo para impedir diferenças entre Kanban,
 * listagem e o indicador compacto do cabeçalho.
 *
 * @version 1.0.0
 * RELEASE: 2026-10-04 v1.0.0 - Extração da regra oficial de tempo ativo.
 */

/** Calcula o tempo efetivamente trabalhado, descontando pausas concluídas. */
export function calculateTaskActiveSeconds(
  startedAt: string | null,
  isPaused: boolean,
  totalPauseDurationSeconds: number,
  currentPauseStartedAt: string | null,
  completedAt: string | null = null,
  cancelledAt: string | null = null,
  now = Date.now(),
): number {
  if (!startedAt) return 0;

  const started = new Date(startedAt).getTime();
  let reference = now;
  if (completedAt) reference = new Date(completedAt).getTime();
  else if (cancelledAt) reference = new Date(cancelledAt).getTime();
  else if (isPaused && currentPauseStartedAt) reference = new Date(currentPauseStartedAt).getTime();

  const elapsed = (reference - started) / 1000;
  // Dados legados podem ter pausa maior que o intervalo; nesse caso ela é ignorada.
  const pauses = totalPauseDurationSeconds > elapsed ? 0 : totalPauseDurationSeconds;
  return Math.max(0, elapsed - pauses);
}

/** Formata segundos para leitura compacta e estável no cabeçalho e nos cartões. */
export function formatTaskTimer(totalSeconds: number): string {
  if (totalSeconds <= 0) return '00:00';
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}